<div class="documents_wrapper">
  <h3 class="documents_header" i18n="@@uploadTitle">Documents Uploader</h3>
  <div class="documents_content">
      <div class="bc-file-uploader">
        <div *ngIf="(progress$ | async) as progress; else upload">
          <bc-spinner class="progress"></bc-spinner>
        </div>

        <ng-template #upload>
          <dx-file-uploader
            selectButtonText="Select"
            accept="{{ allowedMimeTypesToUpload }}"
            (onValueChanged)="uploadFile($event)"
            uploadMode="useForm">
          </dx-file-uploader>
        </ng-template>

        <ul class="bc-documents-list">
          <li class="bc-documents-list__item" *ngFor="let document of documents">
            <div class="bc-documents-list__cell bc-documents-list__name">
              <a (click)="viewDocument(document._id)" class="link-view-document">{{ document.name }}</a>
            </div>
            <div class="bc-documents-list__cell bc-documents-list__actions">
              <button class="u-unstyled-btn icon-button" type="button" (click)="removeDocument(document._id)">
                <svg class="svg-icon" width="25" height="25">
                  <use xlink:href="#remove-icon"></use>
                </svg>
              </button>
            </div>
          </li>
        </ul>

      </div>
  </div>
</div>
